import React, { useState } from "react";
import "./permissions-type-info.scss";
import {
  GSForm,
  GSQuickFilter,
  GSSidePanelPage,
  GSInput,
  GSInfoGroup,
} from "golfstatus_react_components";
import {
  faChevronLeft,
  faTimesCircle,
  faSearch,
  faCheck,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { OrganizationTypes } from "../../forms/OrganizationTypes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PermissionTypeInfo = () => {
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const getDefaultSearch = () => {
    return (
      <GSInput
        textValue={search}
        rightIconClick={() => {
          setSearch("");
        }}
        rightIcon={faTimesCircle}
        leftIcon={faSearch}
        onChange={(e) => {
          setSearch(e?.target?.value);
        }}
        placeholder="Search Permissions..."
      ></GSInput>
    );
  };

  const getFilteredTypes = () => {
    return OrganizationTypes.filter((type) =>
      type?.label?.toLowerCase?.()?.includes?.(search) || hasRole(type)
    );
  };

  const hasRole = (type) => {
    return type.roles.find(r => r?.toLowerCase?.().includes(search?.toLocaleLowerCase?.()))
  }

  const hasAccess = (type, value) => {
    return type?.roles?.includes?.(value);
  };

  const getStatus = (type, value) => {
    return hasAccess(type, value) ? "granted" : "denied";
  };

  const getTypeInfoGroup = (type) => {
    return [
      {
        fit: "stretch",
        sections: [
          {
            sectionItems: [{ type: "secondary", value: type.label }],
          },
        ],
      },
      {
        sections: [
          {
            sectionItems: [
              {
                type: `${hasAccess(type, "Organization Member") ? "primary" : "secondary"} no-wrap`,
                value: (
                  <div
                    className={`org-type ${getStatus(
                      type,
                      "Organization Member"
                    )}`}
                  >
                    <FontAwesomeIcon
                      icon={
                        hasAccess(type, "Organization Member")
                          ? faCheck
                          : faTimes
                      }
                    />
                    Organization Member
                  </div>
                ),
              },
            ],
          },
          {
            sectionItems: [
              {
                type: `${hasAccess(type, "Tournament Organizer") ? "primary" : "secondary"} no-wrap`,
                value: (
                  <div
                    className={`org-type ${getStatus(
                      type,
                      "Tournament Organizer"
                    )}`}
                  >
                    <FontAwesomeIcon
                      icon={
                        hasAccess(type, "Tournament Organizer")
                          ? faCheck
                          : faTimes
                      }
                    />
                    Tournament Organizer
                  </div>
                ),
              },
            ],
          },
          {
            sectionItems: [
              {
                type: `${hasAccess(type, "Tournament Manager") ? "primary" : "secondary"} no-wrap`,
                value: (
                  <div
                    className={`org-type ${getStatus(
                      type,
                      "Tournament Manager"
                    )}`}
                  >
                    <FontAwesomeIcon
                      icon={
                        hasAccess(type, "Tournament Manager")
                          ? faCheck
                          : faTimes
                      }
                    />
                    Tournament Manager
                  </div>
                ),
              },
            ],
          },
        ],
      },
    ];
  };

  const getQuickFilter = () => {
    return (
      <GSQuickFilter
        getDefaultSearch={getDefaultSearch}
        filteredList={getFilteredTypes()}
        getItem={(item) => (
          <GSInfoGroup
            type="list-item x-large-pad large-gap"
            dataGroups={getTypeInfoGroup(item)}
          ></GSInfoGroup>
        )}
      />
    );
  };

  const getForm = () => {
    return [
      {
        type: "vertical",
        fields: [
          { value: getQuickFilter(), customView: true, isEditable: false },
        ],
      },
    ];
  };

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    return {
      title: "Permission Types",
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getContent = () => {
    return <GSForm formTitle="Permission Types" formSections={getForm()} />;
  };

  return (
    <permission-type-info>
      <GSSidePanelPage header={getNavigation()} content={getContent()} />
    </permission-type-info>
  );
};

export default PermissionTypeInfo;
